import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const get_build_version_info = () => {
    return axiosClient.get(`/hiclasstv/version`, options);
}

export const get_hiclasstv_info = () => {
    return axiosClient.get(`/`, options);
}

export const get_refresh_hiclasstv_info = () => {
    return axiosClient.get(`/hiclasstv/info`, options);
}

export const get_refresh_my_friend_list = ({ userSeq }) => {
    return axiosClient.get(`/hiclasstv/${userSeq}/list?kind=friend`, options);
}

export const get_download_info = () => {
    return axiosClient.get(`/hiclasstv/info/download`, options);
}

// 260806 기존 REST_API_HOST_ADD 정책을 그대로 사용해 개발 SmartTV 진단 batch를 전송한다.
export const post_smarttv_media_trace = data => {
    return axiosClient.post(`/diagnostic/smarttv-media-trace`, data, { ...options, timeout: 5000 });
}